import axios from '../request/http';

const integral = {
    // 积分事项分类列表V2
    getImVillageScoreItemCategoryListV2(params) {
        return axios.get("/hemei-admin/village/score/item/getImVillageScoreItemCategoryListV2", { params });
    },
    // 查询积分分类列表
    getImVillageScoreItemCategoryListV1(params) {
        return axios.get("/hemei-admin/village/score/item/getImVillageScoreItemCategoryListV1", { params });
    },
    // 新建乡村积分事项分类
    addVillageScoreItemCategory(data) {
        return axios.post("/hemei-admin/village/score/item/addVillageScoreItemCategory", data);
    },
    // 编辑乡村积分事项分类名称
    editVillageScoreItemCategoryName(params) {
        return axios.get("/hemei-admin/village/score/item/editVillageScoreItemCategoryName", { params });
    },
    // 检查积分事项是否可以删除
    checkScoreItemDeleteStatus(params) {
        return axios.get("/hemei-admin/village/score/item/checkScoreItemDeleteStatus", { params });
    },
    // 更新积分事项分类状态
    updateVillageScoreItemCategoryStatus(data) {
        return axios.post("/hemei-admin/village/score/item/updateVillageScoreItemCategoryStatus", data);
    },
    // 检查积分分类是否可以修改状态
    checkUpDownShelvesStatus(data) {
        return axios.post("/hemei-admin/village/score/item/checkUpDownShelvesStatus", data);
    },
    // 查询某一乡村没有创建积分规则的积分事项分类
    getNotItemCategoryList(params) {
        return axios.get("/hemei-admin/village/score/item/getNotItemCategoryList", { params });
    },
    // 查询积分分类事项
    getScoreItemByCategoryId(params) {
        return axios.get("/hemei-admin/village/score/item/getScoreItemByCategoryId", { params });
    },
    // 获取家庭积分列表
    getFamilyScoreStatisticsList(params) {
        return axios.get("/hemei-admin/village/score/getFamilyScoreStatisticsList", { params });
    },
    // 根据乡村id，获取乡村积分数据
    getVillageScoreStatistics(params) {
        return axios.get("/hemei-admin/village/score/getVillageScoreStatistics", { params });
    },
    // 获取家庭成员 积分详情，家庭待归档积分
    getFamilyMemberScoreList(params) {
        return axios.get("/hemei-admin/village/score/getFamilyMemberScoreList", { params });
    },
    // 获取个人积分申请记录详情，个人待归档积分
    getUserScoreApprovalRecord(params) {
        return axios.get("/hemei-admin/village/score/getUserScoreApprovalRecord", { params });
    },
    // 获取某一个申请的积分审批详情
    getScoreApprovalDetail(params) {
        return axios.get("/hemei-admin/village/score/getScoreApprovalDetail", { params });
    },
    // 新建乡村积分事项
    addVillageScoreItem(data) {
        return axios.post("/hemei-admin/village/score/item/addVillageScoreItem", data);
    },
    // 更新乡村积分事项列表
    updateVillageScoreItemList(data) {
        return axios.post("/hemei-admin/village/score/item/updateVillageScoreItemList", data);
    },
}

export default integral;